const StepWrapper = ({ title, subtitle, children, noPadding = false }) => {
  return (
    <div
      className={`flex flex-col gap-2 animate-fade-in ${noPadding ? "" : "pb-16 md:pb-[65px]"}`}
    >
      {title && (
        <h2 className="font-title text-[1.6rem] md:text-[2.1rem] font-normal leading-[1.25] md:leading-[1.2] text-center text-main">
          {title}
        </h2>
      )}
      {subtitle && (
        <p className="text-[0.9rem] md:text-base leading-[1.4] md:leading-[1.55] text-center text-gray mb-2 md:mb-4">
          {subtitle}
        </p>
      )}
      {children}
    </div>
  );
};

export default StepWrapper;
